'use client';

import Modal from './Modal/Modal';
import { useAppointmentModalStore, AppointmentModalState } from '@/store/useAppointmentModalStore';

// Propriétés du provider pour configurer la modale
interface AppointmentModalProviderProps {
  title?: string;
  description?: string;
  webhookUrl: string;
}

// Ce composant va être placé une seule fois dans votre layout principal
export const AppointmentModalProvider: React.FC<AppointmentModalProviderProps> = ({
  title = 'Prendre rendez-vous',
  description = 'Veuillez remplir ce formulaire pour planifier une séance de sophrologie.',
  webhookUrl,
}) => {
  // Récupérer directement isOpen et close du store
  // En utilisant des sélecteurs séparés pour éviter des re-renders inutiles
  const isOpen = useAppointmentModalStore((state: AppointmentModalState) => state.isOpen);
  const close = useAppointmentModalStore((state: AppointmentModalState) => state.close);
  
  return (
    <>      
      <Modal
        isOpen={isOpen}
        onClose={() => {
          console.log("ModalProvider - onClose appelé");
          close();
        }}
        title={title}
        description={description}
        webhookUrl={webhookUrl}
      />
    </>
  );
};

export default AppointmentModalProvider;